var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7573 32.1406C37.3926 30.7656 34.0875 28.759 32.4839 27.9503C30.3956 26.8984 30.2237 26.8125 28.5823 28.0319C27.4875 28.8458 26.7596 29.5728 25.4783 29.2995C24.1969 29.0262 21.4126 27.4854 18.9745 25.055C16.5365 22.6247 14.9062 19.7596 14.6321 18.4825C14.358 17.2055 15.097 16.4862 15.9031 15.3888C17.0392 13.8419 16.9533 13.5841 15.9822 11.4958C15.2251 9.87161 13.16 6.59739 11.7798 5.23958C10.3034 3.78122 10.3034 4.03903 9.35209 4.43435C8.57757 4.76015 7.83454 5.15626 7.13233 5.61771C5.75733 6.53122 4.9942 7.29005 4.46053 8.43044C3.92686 9.57083 3.68709 12.2443 6.44311 17.2511C9.19912 22.2578 11.1327 24.8179 15.1348 28.8088C19.1369 32.7997 22.2144 34.9456 26.7132 37.4687C32.2785 40.5857 34.4132 39.9781 35.557 39.4453C36.7008 38.9125 37.4631 38.1562 38.3783 36.7812C38.841 36.0802 39.238 35.338 39.5643 34.564C39.9605 33.6161 40.2183 33.6161 38.7573 32.1406Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFooter);
export default __webpack_public_path__ + "static/media/phone_footer.e566873b5162ecbf1f575297032efb7e.svg";
export { ForwardRef as ReactComponent };